import { render } from "./tabulate-data.vue?vue&type=template&id=2822299e&scoped=true"
import script from "./tabulate-data.vue?vue&type=script&lang=js"
export * from "./tabulate-data.vue?vue&type=script&lang=js"

import "./tabulate-data.vue?vue&type=style&index=0&id=2822299e&scoped=scoped&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2822299e"]])

export default __exports__